import axios from "axios";

const appUrl = process.env.MIX_APP_URL;

const audioBookService = {
  async getAudioBookById(id) {
    return  axios
        .get(appUrl + '/api/audio-books/' + id)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async updateAudioBook(id) {
    return  axios
        .put(appUrl + '/api/audio-books/' + id)
        .then(response => response.data)
        .catch(err => console.log(err));
  },
  async deleteAudioBook(id) {
    return  axios
        .delete(appUrl + '/api/audio-books/' + id)
        .then(response => response.data)
        .catch(err => console.log(err));
  }
};

export default audioBookService;
